import { render } from "./SupportTicket.vue?vue&type=template&id=83ccf6ae&scoped=true"
import script from "./SupportTicket.vue?vue&type=script&lang=js"
export * from "./SupportTicket.vue?vue&type=script&lang=js"

import "@/styles/pages/SupportTicket.scss?vue&type=style&index=0&id=83ccf6ae&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ccf6ae"]])

export default __exports__